import { genericPage, getServerSidePropsHelper } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

const path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'meu3catinfo'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'meu3catinfo', slug];
    const options = {
        slugs: path
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
